/* tslint:disable */

/**
 */
export class TicketPrice {
    id?: number;
    ticket_type_id?: number;
    price?: number;
    limit_number?: number;
    charge_limit?: number;
    created_at?: string;
    updated_at?: string;
}
